import { DEV_MODE } from "@/common/config";

export const MEDIATORS_URL = DEV_MODE
  ? "http://localhost:5173"
  : "https://mediators.kz";
